import requestOffers from '@/actions/data/requestOffers';

export const toggleFilterProposal = () => async (dispatch, getState: RootStateGetter) => {
  const isCurrentlyApplies = getState().customFilter.filterProposalData.filterApplied;
  await dispatch({ type: isCurrentlyApplies ? 'UNAPPLY_FILTER_PROPOSAL' : 'APPLY_FILTER_PROPOSAL' });
  await dispatch(requestOffers(false, false, true));
};
